import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import HomeSliderItem from './HomeSliderItem';
import {Link} from "@reach/router";

class HomeSlider extends Component{
  render(){
    var videos = [];
    this.props.data.items.forEach((item, index) => {
      videos.push(
        <HomeSliderItem key={'vi' + index} data={item}/>
      );
    });
    return(
      <>
      <div className="home-slider-content">
        {videos}
        <div className="container">
          <Link className="more" to="../video"><span>Lihat video {this.props.nick} disini</span><span><img src="http://resources.triyakom.com/mini_portal/right-chevron.svg" /></span></Link>
        </div>
      </div>
      </>
    );
  }
}

export default HomeSlider;
